import React from 'react';
import gql from 'graphql-tag';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { ChildProps } from 'react-apollo';
import {
  CoreCreditCardWalletEditFormLayout,
} from '../schemas/rql';
import { WithRouterProps } from 'react-router';

import { RCLoadingBars } from '@reverbdotcom/cadence/components';
import CreditCardEditForm, { CreditCardEditFormFragment } from './credit_card_edit_form';
import CreditCardDeleteButton, { CreditCardDeleteButtonFragment } from './CreditCardDeleteButton';

type Props = ChildProps<unknown, CoreCreditCardWalletEditFormLayout.Query> & WithRouterProps;

export function CreditCardWalletEditFormLayout(props: Props) {
  if (!props.data || props.data.loading) {
    return (
      <div className="d-flex fx-justify-center mtb-1">
        <RCLoadingBars />
      </div>
    );
  }

  const creditCards = props.data.me?.creditCards;
  const selectedCard = creditCards.find(card => card.id === props.params.creditCardId);
  if (!selectedCard) { return null; }

  return (
    <>
      <CreditCardEditForm
        creditCard={selectedCard}
        countries={props.data.countries.countries}
      />
      {!selectedCard.primaryBilling &&
        <CreditCardDeleteButton
          creditCard={selectedCard}
        />
      }
    </>
  );
}

const withQuery = withGraphql<Props>(
  gql`
    query Core_CreditCardWallet_EditFormLayout {
      countries {
        countries {
          countryCode
          name
          subregionRequired
          subregions {
            code
            name
          }
        }
      }
      me {
        uuid
        creditCards {
          id
          primaryBilling
        }
        ...CreditCardEditFormFields
        ...CreditCardDeleteButtonFields
      }
    }
    ${CreditCardEditFormFragment}
    ${CreditCardDeleteButtonFragment}
  `,
);

export default withQuery(CreditCardWalletEditFormLayout);
